import { getAllMonthlySlots } from "../../../../redux/member-slices/appointments.slice";
import { Box, Grid2 as Grid, Typography, IconButton, Paper } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import Icons from "../../../../assets/js/Icons";
import moment from "moment";

function AptCalender({ onSelect }) {
  const dispatch = useDispatch();
  const [slots, setSlots] = useState([]);
  const { data } = useSelector((s) => s.otherSlice);
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(moment());
  const startDayIndex = currentMonth.clone().startOf("month").day();

  const today = moment();
  const availableSet = useMemo(() =>
    slots.map((d) => moment.utc(d.date).local().format("YYYY-MM-DD")),
    [slots]
  );

  const days = useMemo(() => {
    const start = currentMonth.clone().startOf("month");
    const end = currentMonth.clone().endOf("month");

    const day = start.clone();
    const arr = [];

    while (day.isSameOrBefore(end)) {
      arr.push(day.clone());
      day.add(1, "day");
    }

    return arr;
  }, [currentMonth]);

  async function handleMonthChange(month) {
    const { data: resData } = await dispatch(getAllMonthlySlots({
      specialistId: data?.specialistId,
      month: month?.month() + 1,
      year: month?.year(),
    })).unwrap()
    if (resData?.slots) setSlots(resData?.slots)
    // eslint-disable-next-line
  };

  const getDayStyles = (day) => {
    const formatted = day.format("YYYY-MM-DD");
    const isPast = day.isBefore(today, "day");
    const isToday = day.isSame(today, "day");
    const isAvailable = availableSet.includes(formatted);
    const isSelected = selectedDate?.isSame(day, "day");

    // ❌ Past
    if (isPast) {
      return {
        color: "grey.500",
        bgcolor: "grey.50",
        userSelect: "none",
      };
    }

    // 🔵 Selected
    if (isSelected) {
      return {
        bgcolor: "blue.400",
        color: "#fff"
      };
    }

    // 🟠 Today
    if (isToday) {
      return {
        bgcolor: "orange.400",
        color: "#fff"
      };
    }

    // 🟢 Available
    if (isAvailable) {
      return {
        bgcolor: "green.400",
        color: "#fff"
      };
    }

    // ⚪ Default
    return {
      bgcolor: "grey.300",
      color: "grey.600"
    };
  };

  const handleSelect = (day) => {
    const isPast = day.isBefore(today, "day");
    const hasSlots = availableSet.includes(day.clone().format("YYYY-MM-DD"))
    if (isPast) return;

    setSelectedDate(day);
    onSelect && onSelect(day.format("YYYY-MM-DD"), hasSlots);
  };

  useEffect(() => {
    handleMonthChange(currentMonth)
    // eslint-disable-next-line
  }, [])

  return (
    <Paper elevation={3} sx={{ mx: "auto" }}>

      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <IconButton
          sx={{ svg: { transform: "rotate(180deg)" } }}
          disabled={!today.isBefore(currentMonth, "month")}
          onClick={() => setCurrentMonth(prev => {
            const previous = prev.clone().subtract(1, "month")
            handleMonthChange(previous)
            return previous
          })}
        >
          <Icons.ArrowRight1 />
        </IconButton>

        <Typography variant="h6">
          {currentMonth.format("MMMM YYYY")}
        </Typography>

        <IconButton
          disabled={currentMonth.isSameOrAfter(
            today.clone().startOf("month").add(12, "month"),
            "month"
          )}
          onClick={() =>
            setCurrentMonth(prev => {
              const next = prev.clone().add(1, "month");
              handleMonthChange(next)
              return next;
            })
          }
        >
          <Icons.ArrowRight1 />
        </IconButton>
      </Box>

      {/* Week Days */}
      <Grid container spacing={1} mb={1}>
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
          <Grid size={12 / 7} key={d}>
            <Typography display="block" align="center" variant="caption">{d}</Typography>
          </Grid>
        ))}
      </Grid>

      {/* Days */}
      <Grid container spacing={1}>
        {/* Empty boxes before month start */}
        {Array.from({ length: startDayIndex }).map((_, i) => (
          <Grid size={12 / 7} key={`empty-${i}`} />
        ))}

        {/* Actual days */}
        {days.map((day) => {
          const isPast = day.isBefore(today, "day");

          return (
            <Grid size={12 / 7} key={day.format()}>
              <Box
                onClick={() => handleSelect(day)}
                sx={{
                  p: 1.2,
                  borderRadius: 2,
                  textAlign: "center",
                  cursor: isPast ? "not-allowed" : "pointer",
                  ...getDayStyles(day)
                }}
              >
                <Typography variant="body2">{day.date()}</Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>

    </Paper>
  );
};

export default AptCalender;